"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CausalityCommentListElement = exports.CausalityCommentList = exports.CausalityCommentSection = void 0;
var React = require("react");
var moment = require("moment");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../App");
var generic_1 = require("../generic");
var CausalityCommentSection = (function (_super) {
    __extends(CausalityCommentSection, _super);
    function CausalityCommentSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CausalityCommentSection.prototype.render = function () {
        var _a, _b;
        var props = this.props;
        return (React.createElement("div", null,
            React.createElement(generic_1.Header, { text: gettext("Comments") }),
            React.createElement(generic_1.ExpandingTextArea, { placeholder: gettext("Type comment here"), submitButtonText: gettext("Post Comment"), onSubmit: (_a = props.onSubmit) === null || _a === void 0 ? void 0 : _a.bind(this), onChange: (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.bind(this), value: "" }),
            React.createElement(CausalityCommentList, { comments: props.comments, isCause: props.isCause })));
    };
    CausalityCommentSection = __decorate([
        mobx_react_1.observer
    ], CausalityCommentSection);
    return CausalityCommentSection;
}(React.Component));
exports.CausalityCommentSection = CausalityCommentSection;
var CausalityCommentList = (function (_super) {
    __extends(CausalityCommentList, _super);
    function CausalityCommentList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CausalityCommentList.prototype.render = function () {
        var _a = this.props, comments = _a.comments, isCause = _a.isCause;
        return (React.createElement("div", { className: "CommentList" }, comments.length > 0 ? (comments.map(function (comment) { return (React.createElement(CausalityCommentListElement, { key: comment.id, comment: comment, isCause: isCause })); })) : (React.createElement("p", { className: "CommentList__NoComments" }, gettext("No comments added") + "."))));
    };
    CausalityCommentList = __decorate([
        mobx_react_1.observer
    ], CausalityCommentList);
    return CausalityCommentList;
}(React.Component));
exports.CausalityCommentList = CausalityCommentList;
var CausalityCommentListElement = (function (_super) {
    __extends(CausalityCommentListElement, _super);
    function CausalityCommentListElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CausalityCommentListElement.prototype, "dialog", {
        get: function () {
            return this.props.isCause ? App_1.store.causeDialog : App_1.store.effectDialog;
        },
        enumerable: false,
        configurable: true
    });
    CausalityCommentListElement.prototype.putComment = function (comment) {
        var values = { comment: comment };
        this.dialog.saveComment(this.props.comment, values);
    };
    CausalityCommentListElement.prototype.deleteComment = function () {
        this.dialog.deleteComment(this.props.comment);
    };
    CausalityCommentListElement.prototype.render = function () {
        var comment = this.props.comment;
        var dialog = this.dialog;
        var isOwner = comment.owner === dialog.userProxyId;
        return (React.createElement("div", { className: "CommentListElement" },
            React.createElement("div", { className: "d-flex" },
                React.createElement("div", { className: "font-weight-bold" }, comment.owner_full_name),
                React.createElement("div", { className: "flex-grow-1" }),
                React.createElement("div", null, moment(comment.date).format("L LT")),
                (isOwner || dialog.hasDeleteCommentPerm) &&
                    React.createElement("span", { className: "pl-3", onClick: this.deleteComment.bind(this) },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.trash }))),
            React.createElement("div", { className: "CommentListElement__Comment" }, isOwner ? (React.createElement(generic_1.EditableText, { value: comment.comment, onSubmit: this.putComment.bind(this) })) : (React.createElement("div", null, comment.comment))),
            React.createElement(generic_1.Clearfix, null)));
    };
    CausalityCommentListElement = __decorate([
        mobx_react_1.observer
    ], CausalityCommentListElement);
    return CausalityCommentListElement;
}(React.Component));
exports.CausalityCommentListElement = CausalityCommentListElement;
